import AuthService, { ConnectionState } from "services/AuthService";
import { config } from "config";
import EventsEmitter from "events/EventsEmitter";

const handleError = (errorCode: number) => {
    switch (true) {

        case errorCode === 401:
        case errorCode === 403:
        case errorCode === 417: {
            if (AuthService.connectionState === ConnectionState.CONNECTED && AuthService.accessToken !== "") {
                AuthService.loginRedirect();
            }
            AuthService.connectionState = ConnectionState.ERROR;
            return { loaded: true, error: true };
        }
        case errorCode === 404: {

            return { loaded: true, error: true };
        }
        case errorCode > 400: {
            EventsEmitter.emit("criticalError", {
                message: errorCode + " Error",
                redirect: false,
            });
            return { loaded: true, error: true };
        }
    }
};

export function api<T>(path: string = "", options?: any): Promise<T> {
    let format: string, body: any;
    if (options) {
        format = options.format ? options.format : "";
        body = options.body ? options.body : undefined;
    }

    let headers = {};
    const token = AuthService.getToken();
    if (token) {
        headers = {
            Authorization: "Bearer " + AuthService.getToken(),
        };
    }

    const url = path.includes("http:") || path.includes("https:") ? path : config.api.baseUrl + path;

    return fetch(url, {
        headers: headers,
        method: body === undefined ? "GET" : "POST",
        //For some API calls, such as delete, we need to send a FormData object instead of a JSON string.
        body: body && Object.getPrototypeOf(body).toString().indexOf("FormData") !== -1 ? body : JSON.stringify(body),
    })
        .then((response) => {
           
            if (response.ok) {
                if (format === "text") {
                    return response.text();
                } else {
                    return response.json();
                }
            } 
            else {
                //const code: number = response.status;
                //return handleError(code);
                return { loaded: true, error: true };
            }
        })
        .catch((error: any) => {
                       
            EventsEmitter.emit("criticalError", {
                message: error + " Error",
                redirect: false,
            });
            return handleError(error);
            //return { loaded: true, error: true };
        });
        
}

export function download<T>(path: string = "", options?: any): Promise<T> {
    let format: string, body: any;
    if (options) {
        format = options.format ? options.format : "";
        body = options.body ? options.body : undefined;
    }

    let headers = {};
    const token = AuthService.getToken();
    if (token) {
        headers = {
            Authorization: "Bearer " + AuthService.getToken(),
        };
    }

    const url = path.includes("http:") || path.includes("https:") ? path : config.api.baseUrl + path;
    return fetch(url, {
        headers: headers,
        method: body === undefined ? "GET" : "POST",
        //For some API calls, such as delete, we need to send a FormData object instead of a JSON string.
        body: body && Object.getPrototypeOf(body).toString().indexOf("FormData") !== -1 ? body : JSON.stringify(body),
    })
        .then(async (response) => {
            if (response.ok) {
                if (format === "text") {
                    return response.text();
                } else {
                    //return response.json();
                    const results = await _readBody(response);
                    //console.log("results:", results);
                    return JSON.parse(results);
                }
            } else {
                const code: number = response.status;
                return handleError(code);
            }
        })
        .catch((error: any) => {
            EventsEmitter.emit("criticalError", {
                message: error + " Error",
                redirect: true,
            });
            return { loaded: true, error: true };
        });
}

const _readBody = async (response: any) => {
    const reader = response.body.getReader();
    const length = response.headers.get("content-length");

    let loading = true;
    let received = 0;
    const chunks = [];
    while (loading) {
        const { done, value } = await reader.read();
        const payload = { detail: { received, length, loading } };
        const onProgress = new CustomEvent("fetch-progress", payload);
        const onFinished = new CustomEvent("fetch-finished", payload);
        if (done) {
            loading = false;
            window.dispatchEvent(onFinished);
        } else {
            chunks.push(value);
            received += value.length;
            //console.log(`Received ${received} bytes`);
            window.dispatchEvent(onProgress);
        }
    }

    let body = new Uint8Array(received);
    let position = 0;
    for (let chunk of chunks) {
        body.set(chunk, position);
        position += chunk.length;
    }
    const utf8decoder = new TextDecoder();
    return utf8decoder.decode(body);
};

const setProgressbarValue = (payload: any) => {
    const { received, length } = payload;
    const value: number = parseInt(((received / length) * 100).toFixed(2));
    //console.log("++++++++++++++++++++++value:", value);
    //EventsEmitter.emit("projects_progress", value);
    EventsEmitter.emit("current_projects_progress", value);
};

window.addEventListener("fetch-progress", (e: any) => {
    setProgressbarValue(e.detail);
});

window.addEventListener("fetch-finished", (e: any) => {
    setProgressbarValue(e.detail);
});
